import React, { useState, useEffect } from "react";
import axios from "axios";
import { motion } from "framer-motion";

const SETTINGS_API = "https://lze2pvioqi.execute-api.us-east-1.amazonaws.com/cookies"; // Replace with your API Gateway URL

const CookiesDashboard = () => {
  const [cookiesEnabled, setCookiesEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    // Fetch the global cookie setting from backend
    axios
      .post(SETTINGS_API, { action: "get" })
      .then((res) => {
        setCookiesEnabled(res.data.cookiesEnabled);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching settings:", err);
        setError("Failed to fetch settings");
        setLoading(false);
      });
  }, []);

  const toggleGlobalCookies = async () => {
    try {
      setLoading(true);
      const res = await axios.post(SETTINGS_API, { action: "toggle" });
      setCookiesEnabled(res.data.cookiesEnabled);
      setLoading(false);
    } catch (error) {
      console.error("Error updating settings:", error);
      setError("Failed to update settings");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex rounded-lg items-center justify-center bg-gray-700">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md text-center">
        <motion.h2
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-3xl font-bold text-gray-900 bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-500"
        >
          Cookie Consent
        </motion.h2>

        {loading ? (
          <p className="mt-4 text-blue-600 font-bold">Loading...</p>
        ) : error ? (
          <p className="mt-4 text-red-500">{error}</p>
        ) : (
          <div className="mt-6">
            <p className="text-lg font-medium">
              Cookies are currently:{" "}
              <span className={cookiesEnabled ? "text-green-600" : "text-red-600"}>
                {cookiesEnabled ? "ON ✅" : "OFF ❌"}
              </span>
            </p>
            <button
              className={`mt-6 px-6 py-2 rounded-lg text-white font-medium shadow-md transition-all ${
                cookiesEnabled ? "bg-red-600 hover:bg-red-700" : "bg-blue-600 hover:bg-blue-700"
              }`}
              onClick={toggleGlobalCookies}
              disabled={loading}
            >
              {cookiesEnabled ? "Turn OFF Cookies" : "Turn ON Cookies"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CookiesDashboard;
